import { ProjectAccessTypes, ToolProject } from "@/shared/projects/ToolProject.interface";
import { ToolAppTypes } from "@/shared/tool-app.types";

export interface SkimmedToolProjectData {
    id: ToolProject["id"];
    uuid: ToolProject["uuid"];
    access: ProjectAccessTypes;
    name: ToolProject["name"];
    tool?: ToolAppTypes;
}

export function makeSkimmedToolProjectData(
    project: ToolProject | SkimmedToolProjectData,
    tool?: ToolAppTypes
): SkimmedToolProjectData {
    const { id, uuid, name, access } = project;
    return {
        id,
        uuid,
        name,
        access,
        tool,
    };
}
